<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar />
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-muted mb-0 hover-cursor" @click="toPage('/order')">&nbsp;Order&nbsp;</p>
                        <p class="text-primary mb-0 hover-cursor">/&nbsp;create</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <h5 class="card-title mb-4">Create Order</h5>
                                <div class="one-line" :class="{ 'error-text': $v.companyAdd.$error }">
                                    <span class="select-company"> Select Company : </span>
                                    <div v-if="loadingTable == true"><img src="~@/assets/images/load-button.gif" /></div>
                                    <multiselect v-model="companyAdd" :options="dataCompany" label="companyName" :allow-empty="true" deselect-label="Can't remove this value" v-else @input='$v.companyAdd.$touch()' :class="{'error-field' : $v.companyAdd.$error}"></multiselect>
                                    <div style="width: 292px;"></div>
                                </div>
                                <div class="one-line">
                                <div style="width: 139px;"> </div>
                                <div class="error-text-message" v-if="$v.companyAdd.$error">Company must be choose</div>
                            </div>

                                <div v-if="loadingTable == true"><img src="~@/assets/images/load-button.gif" /></div>
                                <div v-for="(input, index) in dataOrder" style="margin-top: 15px;" :key="`product-${index}`">
                                    <div v-if="!loadingTable" style="display: flex; flex-wrap: wrap; width: 100%;">
                                    <div style="flex-wrap: wrap; width: 27%; margin-right: 5px;">
                                        <multiselect
                                            v-model="dataOrder[index].productCategory"
                                            :options="typeCatalog"
                                            label="catalogType"
                                            @select="inputResetAdd('category',index)"
                                            :allow-empty="false"
                                            deselect-label=""
                                            select-label=""
                                            class="mr-1"
                                            @input="getProductName(index)"
                                            :class="{'error-field' : $v.dataOrder.$each[index].productCategory.$error}"
                                        ></multiselect>
                                        <div class="error-text-message mb-2" v-if="$v.dataOrder.$each[index].productCategory.$error">Category must be choose</div>
                                    </div>
                                    <div style="flex-wrap: wrap; width: 27%; margin-right: 5px;">
                                        <multiselect
                                            v-model="dataOrder[index].productName"
                                            :options="selectProductName[index]"
                                            label="catalogName"
                                            track-by="catalogName"
                                            @select="inputResetAdd('product',index)"
                                            :allow-empty="false"
                                            deselect-label=""
                                            select-label=""
                                            class="mr-1"
                                            @input="getProductVarian(index)"
                                            :class="{'error-field' : $v.dataOrder.$each[index].productName.$error}"
                                            :id="'proname'+index"
                                        ></multiselect>
                                        <div class="error-text-message mb-2" v-if="$v.dataOrder.$each[index].productName.$error">Product name must be choose</div>
                                    </div>
                                    <div style="width: 27%; margin-right: 5px;">
                                        <multiselect
                                            v-model="dataOrder[index].productVarian"
                                            :options="selectProductVarian[index]"
                                            label="specification"
                                            @select="inputResetAdd('varian',index)"
                                            :allow-empty="false"
                                            deselect-label=""
                                            select-label=""
                                            class="mr-1"
                                            @input="getProductCondition(index)"
                                            :class="{'error-field' : $v.dataOrder.$each[index].productVarian.$error}"
                                        ></multiselect>
                                        <div class="error-text-message mb-2" v-if="$v.dataOrder.$each[index].productVarian.$error">Varian must be choose</div>
                                    </div>
                                </div>
                                <div v-if="!loadingTable" style="display: flex; flex-wrap: wrap; width: 100%;">
                                    <div style="flex-wrap: wrap; width: 27%; margin-right: 5px; margin-top: 5px;">
                                        <multiselect
                                            v-model="dataOrder[index].productCondition"
                                            :options="selectCondition[index]"
                                            label="conditionName"
                                            track-by="conditionName"
                                            @select="inputResetAdd('condition',index)"
                                            :allow-empty="false"
                                            deselect-label=""
                                            select-label=""
                                            class="mr-1"
                                            @input="getProductDuration(index)"
                                            :class="{'error-field' : $v.dataOrder.$each[index].productCondition.$error}"
                                        ></multiselect>
                                        <div class="error-text-message mb-2" v-if="$v.dataOrder.$each[index].productCondition.$error">Condition must be choose</div>
                                    </div>
                                    <div style="flex-wrap: wrap; width: 27%; margin-right: 5px; margin-top: 5px;">
                                        <div class="form-group" :class="{ 'form-group--error': $v.dataOrder.$each[index].duration.$error, 'mb-0' : !$v.dataOrder.$each[index].duration.$error}">
                                          <input class="form__input" v-model.trim="dataOrder[index].duration" placeholder="Flex Duration" @change="$v.dataOrder.$each[index].duration.$touch()" @input="$v.dataOrder.$each[index].duration.$touch(), getProductPricing(index)" @keypress="isNumber($event)"/>
                                        </div>
                                        <div class="error mb-0" v-if="!$v.dataOrder.$each[index].duration.required">Flex duration required fields</div>
                                        <div class="error mb-0" v-if="!$v.dataOrder.$each[index].duration.minimum1">Minimum duration is 1 month</div>
                                        <div class="error mb-0" v-if="!$v.dataOrder.$each[index].duration.max60">Maximum duration is 60</div>
                                    </div>
                                    <div style="flex-wrap: wrap; width: 27%; margin-right: 5px; margin-top: 5px;">
                                        <div class="input-group form-group" :class="{ 'form-group--error': $v.dataOrder.$each[index].price.$error, 'mb-0' : !$v.dataOrder.$each[index].price.$error}">
                                            <span class="input-group-addon" style="margin-left: 0px"> <label class="label-addon-rp">Rp</label></span>
                                            <input type="text" class="form-control price" name="price" @keypress="isNumber($event)" v-model.trim="dataOrder[index].price" placeholder="Product Price" @input="$v.dataOrder.$each[index].price.$touch(), inputPrice(index)">
                                        </div>
                                        <div class="error" v-if="!$v.dataOrder.$each[index].price.required">Product price required fields</div>
                                    </div>
                                    <div style="flex-wrap: wrap; width: 19%; margin-right: 5px; margin-top: 5px;">
                                        <div class="form-group" :class="{ 'form-group--error': $v.dataOrder.$each[index].qty.$error }">
                                          <input id="qty0" class="form__input" v-model.trim="dataOrder[index].qty" placeholder="Qty" @input="$v.dataOrder.$each[index].qty.$touch()" @keypress="isNumber($event)"/>
                                        </div>
                                        <div class="error mb-0" v-if="!$v.dataOrder.$each[index].qty.required">Quantity required fields</div>
                                        <div class="error mb-0" v-if="!$v.dataOrder.$each[index].qty.minimum1">Minimum quantity is 1</div>
                                        <div class="error mb-0" v-if="!$v.dataOrder.$each[index].qty.maximum">Maximum quantity is 150</div>
                                    </div>
                                    <div style="width: 8%;" class="align-self-center">
                                        <span class="link text-note" @click="openModal('Add',index)" v-if="dataOrder[index].note == null || dataOrder[index].note == ''">Add Note</span>
                                        <span class="link text-note" @click="openModal('Edit',index)" v-else>Edit Note</span>
                                    </div>
                                    <button type="button" class="btn btn-primary btn-icon-minus" @click="removeRow(index)" v-if="index > 0"><i class="fas fa-trash"></i></button>
                                    <div class="ml-auto" style="width: 17%; margin-top: 5px;" v-if="index == 0">
                                        <button type="button" class="btn form-control btn-primary btn-icon-assign" @click="addRow(plusIdx)" style="height: 38px;">Add Product</button>
                                    </div>
                                </div>
                                </div>
                                <div style="float: right; margin-top: 10px;">
                                    <button class="btn btn-danger" @click="$router.go(-1)">Cancel</button>
                                    <button class="btn btn-primary" @click="submitOrder" v-if="loadingSave == false">Save</button>
                                    <button type="button" class="btn btn-primary" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;" />Save</button>
                                    <div style="width: 108px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <!-- modalAddEmployee -->
            <div class="modal fade" id="modalAdd" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Add Note</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="one-line">
                                <label class="ol-label"> Note </label>
                                <label class="ol-titik2">:</label>
                                <textarea rows="3" name="name" class="form-control form-control-sm" v-model="dataOrder[idxNote].note"></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <!-- <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button> -->
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButton == false" data-dismiss="modal">Ok</button>
                            <!-- <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
            <!-- modalAddEmployee -->
            <div class="modal fade" id="modalEdit" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Edit Note</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="one-line">
                                <label class="ol-label"> Note </label>
                                <label class="ol-titik2">:</label>
                                <textarea rows="3" name="name" class="form-control form-control-sm" v-model="dataOrder[idxNote].note"></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <!-- <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button> -->
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButton == false" data-dismiss="modal">Ok</button>
                            <!-- <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
        </div>
    </div>
</template>

<script>
    import SideBar from "../SideBar";
    import Multiselect from "vue-multiselect";
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import { required } from 'vuelidate/lib/validators'
    export default {
        name: "OrderPage",
        components: {
            SideBar,
            Multiselect,
        },
        data() {
            return {
                spaceRegex: /[\u00A0\uFEFF\u202F]/g,
                admin: "",
                adminId: "",
                permission: [],
                viewDashboard: false,
                viewOrder: false,
                viewReturn: false,
                viewProduct: false,
                viewPairing: false,
                viewReconcile: false,
                viewResolution: false,
                viewLessor: false,
                viewLessee: false,
                viewEmployee: false,
                editOrder: false,
                editReturn: false,
                editProduct: false,
                editPairing: false,
                editReconcile: false,
                editResolution: false,
                editLessor: false,
                editLessee: false,
                editEmployee: false,
                totalPage: 0,
                totalData: 0,
                currentPage: 1,
                orderId: "",
                companyName: "",
                statusOrder: "",
                loadingTable: true,
                loadingTableOrder: true,
                dataOrder: [{
                    productCategory : {
                        catalogType: "Product Category",
                        type: "",
                        product: [],
                    },
                    productName : {
                        catalogName: "Product Name",
                        catalogId: "",
                        price: [],
                    },
                    productVarian :  {
                        productDetail: "Varian",
                        catalogId: "",
                        specification: "Varian"
                    },
                    productCondition : {
                        condition: 0,
                        conditionName: "Condition",
                    },
                    duration: "",
                    price:"",
                    qty: "",
                    note : ''
                }],
                typeCatalog: [],
                addQty: [""],
                addDuration: [""],
                addPrice:[""],
                plusIdx: 0,
                inputs: [""],
                varian: [],
                companyAdd: {
                    companyId: "",
                    companyName: "Select Company",
                },
                dataCompany: [],
                loadingSave: false,
                selectProductName: [[]],
                selectProductVarian: [[]],
                selectProductDuration: [[]],
                selectCondition: [[]],
                itemNote: [],
                idxNote: 0,
                loadingButton: false,
                proName:[],
            };
        },
        validations: {
            companyAdd: {
                requireCompany(companyAdd) {
                    return (companyAdd.companyId != '')
                }
            },
            dataOrder : {
                required,
                $each : {
                    productCategory:{
                        choose (productCategory) {
                            return (productCategory.type != '')
                        }
                    },
                    productName:{
                        choose (productName) {
                            return (productName.catalogId != '')
                        }
                    },
                    productVarian : {
                        choose (productVarian) {
                            return (productVarian.catalogId != '')
                        }
                    },
                    productCondition : {
                        choose (productCondition) {
                            return (productCondition.condition != '0')
                        }
                    },
                    duration : {
                        required,
                        minimum1 (duration){
                            return (duration > 0)
                        },
                        max60 (duration){
                            return (duration <= 60)
                        },
                    },
                    price : {
                        required
                    },
                    qty : {
                        required,
                        minimum1 (addQty){
                            return (addQty > 0)
                        },
                        maximum(addQty){
                            return(addQty <= 150)
                        }
                    }
                }
            },
        },
        computed:{
            // carr() {
            //   return this.selectProductName.map(this.getFullName);
            // }
        },
        methods: {
            tandaPemisahTitik: function (b) {
                var _minus = false;
                if (b < 0) _minus = true;
                b = b.toString();
                b = b.replace(/\./g, "");
                b = b.replace("-", "");
                var c = "";
                var panjang = b.length;
                var j = 0;
                for (var i = panjang; i > 0; i--) {
                    j = j + 1;
                    if (j % 3 == 1 && j != 1) {
                        c = b.substr(i - 1, 1) + "." + c;
                    } else {
                        c = b.substr(i - 1, 1) + c;
                    }
                }
                if (_minus) c = "-" + c;
                return c;
            },
            inputPrice(index){
                this.addPrice.splice(index, 1, this.tandaPemisahTitik(this.addPrice[index]))
            },
            getFullName(item) {
                var array = {
                    catalogName : item.catalogName
                }
              return array;
            },
            getProductPricing(index) {
                // this.addPrice.splice(index, 1, this.tandaPemisahTitik(this.addPrice[index]))
                var same = false
                var idx = 0
                this.dataOrder[index].price = '0'
                for (var i = 0; i < this.selectProductDuration[index].length; i++) {
                    if (this.dataOrder[index].duration === this.selectProductDuration[index][i].tenorValue) {
                        same = true
                        idx = i
                    }
                }
                if (same) {
                    this.dataOrder[index].price = this.tandaPemisahTitik(this.selectProductDuration[index][idx].tenorPrice)
                }
            },
            openModal(x, y) {
                this.idxNote = y;
                $("#modal" + x).modal("show");
            },
            getProductName(x) {
                this.$http
                    .post(
                        process.env.GET_CATALOG_NAME,
                        {
                            catalogType: this.dataOrder[x].productCategory.type,
                        },
                        {
                            headers: { "Asani-Token": localStorage.getItem("jwt") },
                        }
                    )
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                            // this.handleLogout();
                        } else if (response.data.status == 200) {
                            this.selectProductName.splice(x, 1, response.data.content)
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            }
                        })
                    });
            },
            getProductCondition(x) {
                this.$http
                    .post(
                        process.env.GET_CATALOG_CONDITION,
                        {
                            catalogId: this.dataOrder[x].productVarian.catalogId,
                        },
                        {
                            headers: { "Asani-Token": localStorage.getItem("jwt") },
                        }
                    )
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                            // this.handleLogout();
                        } else if (response.data.status == 200) { 
                            this.selectCondition.splice(x, 1, response.data.content);
                            
                            // this.selectCondition = this.selectCondition.map(item => {
                            //     return item.map(condition => {
                            //         return {conditionName : condition}
                            //     })
                            // })

                            this.selectCondition[x] = this.selectCondition[x].map(item => {     
                                return {conditionName : item}
                            })
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            }
                        })
                    });
            },
            getProductVarian(x) {
                this.$http
                    .post(
                        process.env.GET_CATALOG_VARIAN,
                        {
                            catalogName: this.dataOrder[x].productName.catalogName,
                        },
                        {
                            headers: { "Asani-Token": localStorage.getItem("jwt") },
                        }
                    )
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                            // this.handleLogout();
                        } else if (response.data.status == 200) {
                            this.selectProductVarian.splice(x, 1, response.data.content)
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    });
            },
            getProductDuration(x) {
                this.$http
                    .post(
                        process.env.GET_CATALOG_DURATION,
                        {
                            catalogId: this.dataOrder[x].productVarian.catalogId,
                            condition: this.dataOrder[x].productCondition.conditionName,
                        },
                        {
                            headers: { "Asani-Token": localStorage.getItem("jwt") },
                        }
                    )
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                            // this.handleLogout();
                        } else if (response.data.status == 200) {
                            this.selectProductDuration.splice(x, 1, response.data.content);
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    });
            },
            submitOrder() {
                var self = this;
                this.$v.$touch()
                const sentDataOrder = []
                if (!this.$v.$error) {
                    for (var i = 0; i < this.dataOrder.length; i++) {
                        if (this.dataOrder[i].note == null || this.dataOrder[i].note == "") {
                            this.dataOrder[i].note = "";
                        } else if (!this.dataOrder[i].note.replace(/\s/g, "").length) {
                            this.dataOrder[i].note = "";
                        }
                        sentDataOrder.push({
                            catalogId: this.dataOrder[i].productVarian.catalogId,
                            duration: parseInt(this.dataOrder[i].duration),
                            price: parseInt(this.dataOrder[i].price.replaceAll(".","")),
                            insurancePrice: 0,
                            qty: parseInt(this.dataOrder[i].qty),
                            note: this.dataOrder[i].note,
                            condition: this.dataOrder[i].productCondition.conditionName,
                        });
                    }
                    this.loadingSave = true;
                    this.$http
                        .post(
                            process.env.CREATE_ORDER,
                            {
                                adminId: this.adminId,
                                companyId: this.companyAdd.companyId,
                                order: sentDataOrder,
                            },
                            {
                                timeout: 30 * 1000,
                                headers: { "Asani-Token": localStorage.getItem("jwt") },
                            }
                        )
                        .then((response) => {
                            if (response.data.status !== 200) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                });

                                if(response.data.status == 401) {
                                    this.handleLogout();
                                }
                            } else if (response.data.status == 200) {
                                swal("Success", "Order has been created", "success", {
                                    button: "Ok",
                                });
                                // this.sendLog(response.data.content.orderId);
                                this.dataOrder = [{
                                    productCategory : {
                                        catalogType: "Product Category",
                                        type: "",
                                        product: [],
                                    },
                                    productName : {
                                        catalogName: "Product Name",
                                        catalogId: "",
                                        price: [],
                                    },
                                    productVarian :  {
                                        productDetail: "Varian",
                                        catalogId: "",
                                        specification: "Varian"
                                    },
                                    productCondition : {
                                        condition: 0,
                                        conditionName: "Condition",
                                    },
                                    duration: "",
                                    price:"",
                                    qty: "",
                                    note : ''
                                }],
                              
                                this.companyAdd = {
                                    companyId: "",
                                    companyName: "Select Company",
                                };
                                this.plusIdx = 0;
                                this.inputs = [""];

                                this.$router.push({
                                    path: "/order/detail/" + response.data.content.orderId,
                                    query: {
                                        orderCode: response.data.content.orderCode,
                                        companyIdDetail: response.data.content.companyId,
                                    },
                                });
                            }
                            this.loadingSave = false;
                        })
                        .catch(error => {
                            self.loadingSave = false;
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                this.handleLogout()
                                }
                            })
                        });
                }
            },
            addRow(x) {
                this.$v.$touch()
                if (!this.$v.$error) {
                    this.plusIdx = this.plusIdx + 1;
                    this.dataOrder.push(
                        {
                            productCategory : {
                                catalogType: "Product Category",
                                type: "",
                                product: [],
                            },
                            productName : {
                                catalogName: "Product Name",
                                catalogId: "",
                                price: [],
                            },
                            productVarian :  {
                                productDetail: "Varian",
                                catalogId: "",
                                specification: "Varian"
                            },
                            productCondition : {
                                condition: 0,
                                conditionName: "Condition",
                            },
                            duration: "",
                            price:"",
                            qty: "",
                            note : ''
                        }
                    )

                    this.inputs.push("");
                    this.selectProductDuration.push([]);
                    this.selectProductName.push([]);
                    this.selectProductVarian.push([]);
                    this.selectCondition.push([]);
                }
            },
            removeRow(index) {
                this.inputs.splice(index, 1);
                this.dataOrder.splice(index,1)
                this.selectProductDuration.splice(index, 1);
                this.selectProductName.splice(index, 1);
                this.selectProductVarian.splice(index, 1);
                this.selectCondition.splice(index, 1);
            },
            isNumber: function (evt) {
                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            inputResetAdd(x, y) {
                this.$v.$reset()
                if (x == "category") {
                    this.dataOrder[y].productName = {
                        catalogName: "Product Name",
                        catalogId: "",
                        price: [],
                    };
                    this.dataOrder[y].productCondition = {
                        condition: 0,
                        conditionName: "Condition",
                    };
                    // console.log(this.dataOrder[y].productVarian)
                    this.dataOrder[y].productVarian = {
                        productDetail: "Varian",
                        catalogId: "",
                        specification: "Varian"
                    },
                    this.dataOrder[y].qty = "";
                    this.dataOrder[y].duration = "";
                    this.dataOrder[y].price = "";
                    this.selectProductDuration[y] = [];
                } else if (x == "product") {
                    this.dataOrder[y].productCondition = {
                        condition: 0,
                        conditionName: "Condition",
                    };
                    this.dataOrder[y].productVarian = {
                        productDetail: "Varian",
                        catalogId: "",
                        specification: "Varian"
                    };
                    this.dataOrder[y].qty = "";
                    this.dataOrder[y].duration = "";
                    this.dataOrder[y].price = "";
                    this.selectProductDuration[y] = [];
                } else if (x == "varian") {
                    this.dataOrder[y].productCondition = {
                        condition: 0,
                        conditionName: "Condition",
                    };
                    this.dataOrder[y].qty = "";
                    this.dataOrder[y].duration = "";
                    this.dataOrder[y].price = "";
                    this.selectProductDuration[y] = [];
                } else if (x == "condition") {
                    this.dataOrder[y].qty = "";
                    this.dataOrder[y].duration = "";
                    this.dataOrder[y].price = "";
                }
            },
            toPage(e) {
                this.$router.push(e);
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem("jwt");
                localStorage.removeItem("admin_name");
                localStorage.removeItem("roles");
                localStorage.removeItem("user_email");
                localStorage.removeItem("admin_id");
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push("/");
            },
            cekLogin() {
                if (localStorage.getItem("jwt") == null) {
                    this.$router.push("/");
                }
            },
            cekPermission() {
                this.permission = localStorage.getItem("roles").replace(/"/g, "").replace("[", "").replace("]", "").split(",");
                for (var i = 0; i < this.permission.length; i++) {
                    if (this.permission[i] == "1") {
                        this.viewDashboard = true;
                    }
                    if (this.permission[i] == "2.1") {
                        this.viewOrder = true;
                    }
                    if (this.permission[i] == "2.2") {
                        this.editOrder = true;
                    }
                    if (this.permission[i] == "3.1") {
                        this.viewReturn = true;
                    }
                    if (this.permission[i] == "3.2") {
                        this.editReturn = true;
                    }
                    if (this.permission[i] == "4.1") {
                        this.viewProduct = true;
                    }
                    if (this.permission[i] == "4.2") {
                        this.editProduct = true;
                    }
                    if (this.permission[i] == "5.1") {
                        this.viewPairing = true;
                    }
                    if (this.permission[i] == "5.2") {
                        this.editPairing = true;
                    }
                    if (this.permission[i] == "6") {
                        this.viewReconcile = true;
                    }
                    if (this.permission[i] == "7.1") {
                        this.viewResolution = true;
                    }
                    if (this.permission[i] == "7.2") {
                        this.editResolution = true;
                    }
                    if (this.permission[i] == "8.1") {
                        this.viewLessor = true;
                    }
                    if (this.permission[i] == "8.2") {
                        this.editLessor = true;
                    }
                    if (this.permission[i] == "9.1") {
                        this.viewLessee = true;
                    }
                    if (this.permission[i] == "9.2") {
                        this.editLessee = true;
                    }
                    if (this.permission[i] == "10") {
                        this.viewEmployee = true;
                    }
                }
                if (this.viewOrder == false) {
                    this.$router.push("/");
                }
            },
            sidebar() {
                $("#wrapper").toggleClass("toggled");
            },
            getData() {
                this.loadingTable = true;
                this.loadingTableOrder = true;
                this.$http
                    .get(process.env.GET_COMPANY, {
                        headers: { "Asani-Token": localStorage.getItem("jwt") },
                    })
                    .then((response) => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            });
                            this.handleLogout();
                        } else {
                            this.dataCompany = response.data.content;
                            this.loadingTable = false;
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            }
                        })
                    });

                this.$http.get(process.env.GET_CATALOG_ADD, 
                    {
                        headers: { "Asani-Token": localStorage.getItem("jwt") },
                    })
                    .then((response) => {
                        this.typeCatalog = response.data.content.catalogType;
                        // this.tenorProduct = response.data.content.productTenor
                        this.loadingTableOrder = false;
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            }
                        })
                    });
            },
            sendLog(x) {
                var today = new Date();
                var month = today.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                var dateDay = today.getDate();
                if (dateDay < 10) {
                    dateDay = "0" + dateDay;
                }
                var hours = today.getHours();
                if (hours < 10) {
                    hours = "0" + hours;
                }
                var minutes = today.getMinutes();
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                var second = today.getSeconds();
                if (second < 10) {
                    second = "0" + second;
                }
                var date = today.getFullYear() + "-" + month + "-" + dateDay;
                var time = hours + ":" + minutes + ":" + second;
                var dateTime = date + " " + time;
                var admin = this.admin;
                var command = "add-logs";

                this.$http
                    .post(
                        process.env.LOG_URL + "/order/" + x,
                        {
                            codeLogs: 1,
                            params: [],
                        },
                        {
                            headers: { "Asani-Token": localStorage.getItem("jwt") },
                        }
                    )
                    .then((response) => {})
                    .catch(error => {
                        console.log(error);
                    });
            },
        },
        created() {
            this.getData();
            this.admin = localStorage.getItem("admin_name");
            this.adminId = localStorage.getItem("admin_id");
            this.cekLogin();
            this.cekPermission();
        },
    };
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-note{
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  color: blue;
  font-weight: bold;
  font-size: 13px;
}

.qty-add{
  max-width: 60px;
}

.btn-icon-minus{
  margin-right: 95px;
}

.btn-assign{
  border-radius: 5px;
}
.one-line .ol-label{
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-titik2{
  width: 15px;
  margin: 2px 0px;
}
.select-company{
    width: 202px;
    margin: 7px 0px;
}
.one-line{
  display: flex;
  margin: 5px 0px;
}

.pagination{
  padding: 0px 0;
}

.pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover{
  text-decoration: none;
}
.p8 a.page:hover{
  text-decoration: none;
  color: #fff;
}

.p8 .is-active{
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}
.alignright {
  float: right;
}

.pagg{
  display: inline-flex;
  overflow:auto;
}

.total-data{
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}
#wrapperr{
    overflow:auto;
    margin: 5px 3px;
}

#c1{
   float:left;
}

#c2{
  float: right;  
}

.search-table{
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}
.active{
  color: #2797FB;
}
.right-dropdown{
  margin-left: 7px;
}
.account-div{
  margin: 2px 2px;
}
.right-arrow{
  margin-left: auto;
}
.brand-logo{
  width: 120px;
}
.menu-title{
  margin-left: 1.125rem;
}
.menu-title-order{
  margin-left: 1.95rem;
}
.menu-title-payment{
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}
.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}
.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}
   .nav-side-menu ul :not(collapsed) .arrow:before,
   .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  .error-field >>> .multiselect__tags{
    border-color: #f57f6c;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderCreatePage.vue